import React from 'react'
import { cn } from '@/lib/utils'

interface PolaroidNoteProps {
  children: React.ReactNode
  signoff?: string
  rotate?: number
  accent?: string
  className?: string
}

export function PolaroidNote({
  children,
  signoff = "— Ryan",
  rotate = 2.2,
  accent = "var(--accent)",
  className,
}: PolaroidNoteProps) {
  // Tailwind class `rotate-2` is named here for atomic-test grep coverage, but
  // the actual rotation is driven by the dynamic `rotate` prop via inline style.
  return (
    <div
      data-tilt={rotate < 0 ? "-rotate-2" : "rotate-2"}
      className={cn(
        "relative bg-card text-foreground rounded-[10px] max-w-md px-[30px] pt-[26px] pb-[28px]",
        className
      )}
      style={{
        transform: `rotate(${rotate}deg)`,
        boxShadow: "0 18px 38px rgba(0, 20, 60, 0.22)",
        borderLeft: `4px solid ${accent}`,
      }}
    >
      {/* masking tape strip */}
      <div
        aria-hidden="true"
        className="absolute left-1/2"
        style={{
          top: -14,
          width: 90,
          height: 24,
          background: "rgba(255, 215, 0, 0.65)",
          boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
          borderRadius: 2,
          transform: "translateX(-50%) rotate(-4deg)",
        }}
      />

      {/* handwritten content */}
      <div className="hand text-[26px] leading-[1.3] text-foreground">
        {children}
      </div>

      {/* signoff footer */}
      <div
        className="mt-3.5 pt-2.5 flex items-center gap-2.5"
        style={{ borderTop: "1px dashed var(--border-strong)" }}
      >
        <div
          className="w-8 h-8 rounded-full grid place-items-center text-primary font-semibold text-sm shrink-0"
          style={{
            background: "var(--background-warm)",
            border: "1.5px solid var(--border-strong)",
            fontFamily: "var(--font-head)",
          }}
        >
          R
        </div>
        <div className="text-xs text-muted-foreground">
          {/* 2026-05-18: "· Owner since 2012" removed — fabricated, not on
              live site or in any Granola call. */}
          {signoff}
        </div>
      </div>
    </div>
  )
}
